/**
 * created by yxy
 * 阵地维护
 */
import React from "react";
import BaseComponent from "../../../../../base/BaseComponent";
import { TitleIcon } from 'antd';

import {message} from "antd";
import PageTemplate from "../../../components/pageTemplate/PageTemplate";

import TableTemplate from "../../../components/TableTemplate/TableTemplate";
import TabsTemplate from "../../../components/TabsTemplate/TabsTemplate";
import Sta_Date from './sta_Date';
import allSmall  from '../images/allSmall.png';
import {Scrollbars} from "react-custom-scrollbars";
import {formatCount, formatTime} from "../../../../../utils/index";
import * as utils from "../../../../../utils/index";
import { CUSTOM_CONFIG } from "../../../../../config/customConfig";

export default class Popular extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentTab:'',
            tabs:[
                {
                    key: '',
                    name: '全部',
                    src:allSmall,
                },
            ],
            dataSource1:[],
            dataSource2:[],
            codes:[],
        };
    }

    componentDidMount() {
          this.getTabs();
        if(this.props.type==='popular'){
            this.getTopList(this.props.currentTabs)
        }else{
            this.getList(this.props.currentTabs);
        }
    }

    componentWillMount() {
        if (typeof CUSTOM_CONFIG?.NEW_MEDIA?.MEDIA_OVERVIEW_FUNCTION === 'function') {
            this.getfieldKey()
        }
    }

    getfieldKey = () => {
        const fieldKey = this.sysConfigGetValueByKey("fieldKey", "");
        const academySelect = this.sysConfigGetValueByKey("isAcademySelect", '[]');
        let fieldValue;
        try {
          fieldValue = JSON.parse(academySelect)[0] || "";
        } catch {
          fieldValue = ""; // 默认值
        }
        // 发起请求
        this.request({
          url: "/cm-sites-media-consumer/position/management/getCodesByField",
          method: "GET",
          body: { fieldKey, fieldValue },
          callBack: (res) => res && this.setState({ codes: res })
        });
      }

    componentWillUnmount() {

    }
    getTopList = (currentTabs) =>{
        let params ={
            count:CUSTOM_CONFIG?.POSITION_OVERVIEW?.SHOW_TOP_TEN_COUNT || 5,
            type:Number(this.state.currentTab)||'',
            endTime:this.state.endTime?new Date(this.state.endTime).getTime():'',
            startTime:this.state.startTime?new Date(this.state.startTime).getTime():'',
            codes:this.state.codes.length ? this.state.codes : []
        };
        if(currentTabs){
            params.grade = currentTabs
        }else{
            delete params.grade
        }
        this.request({
            url: "/cm-sites-media-consumer/position/overview/getHotPublish",
            method: 'post',
            // contentType:'json',
            body:params,
            callBack: (res) => {
                let dataSource2 = [];
                if(res&&res.length){
                    dataSource2 = res
                }
                this.setState({dataSource2})
            }
        })
    };

    getTabs =() =>{
        this.request({
            url: "/cm-sites-media-consumer/position/overview/getPositionType",
            method: 'get',
            callBack: (res) => {
               if(res&&res.length){
                   res.forEach(item=>{
                       item.key = item.type;
                       item.src = item.logo
                   });
                   this.state.tabs = this.state.tabs.concat(res)
               }
               this.setState({})
            }
        })
    };

    getList = (currentTabs) =>{
        let params ={
            count:5,
            type:Number(this.state.currentTab) || "",
            codes:this.state.codes.length ? this.state.codes : [],
        };

        if(currentTabs){
            params.grade = currentTabs
        }else{
            delete params.grade
        }
        this.request({
            url: "/cm-sites-media-consumer/position/overview/getLatestPublish",
            method: 'post',
            // contentType:'json',
            body:params,
            callBack: (res) => {
              let dataSource1 = [];
              if(res&&res.length){
                  dataSource1 = res
              }
              this.setState({dataSource1})
            }
        })
    };

    //点击最新文章标题
    itemClick(record) {
        if (record.link) {
            utils.openNewWindow(record.link);
        } else {
            message.destroy();
            message.info("无法查看详情");
        }
    }

    /* *
   * 获取表头
* */
    render() {
        let columns = [
            {
                title: '标题',
                dataIndex: 'title',
                width:700,
                ellipsis: true,
                render: (text, record, index) => {
                    return (
                        <div onClick={() => this.itemClick(record)}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', cursor: 'pointer'
                                }}
                                     title={record.title}>{text}</div>
                            </div>
                        </div>

                    )
                }
            },
            {
                title: '发布时间',
                ellipsis: true,
                dataIndex: 'publishDate',
                render: (text, record, index) => {
                    return <div>{text?formatTime(text):''}</div>
                }
            },
            {
                title: '账号名称',
                ellipsis: true,
                dataIndex: 'positionName',
            },
            {
                title: '平台类型',
                dataIndex: 'positionType',
                ellipsis: true,
                render: (text, record, index) => {
                    let {name,src} = '';
                   this.state.tabs&& this.state.tabs.length&& this.state.tabs.forEach(item=>{
                       if(item.type === text){
                           name = item.name;
                           src = item.logo
                       }
                   });
                    return (
                        <div><span>{name} <span><img style={{width: 15,objectFit:'cover'}} src={src} alt=""/></span>  </span></div>
                    )
            },
            },
        ];
        if(this.state.currentTab === ''){
            columns.push( {
                title: '阅读（转评赞）',
                dataIndex: 'readNum',
                ellipsis: true,
                render: (text, record, index) => {
                   return (
                       <div>{record?.positionType === 1? "-" : text ? formatCount(text) : "-"}</div>
                   )
                }

            })
        }else if(this.state.currentTab === "2"){
            columns.push( {
                title: '阅读',
                dataIndex: 'readNum',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : "-"}</div>)
                }
            })
        }else if(this.state.currentTab === "3" || this.state.currentTab === "5"){
            columns.push( {
                title: '转评赞',
                dataIndex: 'readNum',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? text : "-"}</div>)
                }
            })
        }
        columns.push({
            title: '主责单位',
            ellipsis: true,
            dataIndex: 'deptName',
        });


        let selectDateConfig = {
            defaultKey:'全部',
            selectConfig:['全部','近7天','近15天','近30天']
        };
        return(
            <PageTemplate style={{padding:'0px',}} styleOut={{margin:"0px 15px"}}>
                    <div style={{background: '#fff', borderRadius: '5px'}}>
                        <div style={{
                            height: 55,
                            lineHeight: '55px',
                            borderBottom: '1px solid #ebebeb',
                            display:'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{paddingLeft: 20, float: 'left', color: '#000', fontSize: '16px'}}>
                                {this.props.title}
                            {
                                typeof CUSTOM_CONFIG?.NEW_MEDIA?.MEDIA_OVERVIEW_FUNCTION === 'function' ?
                                    CUSTOM_CONFIG?.NEW_MEDIA?.MEDIA_OVERVIEW_FUNCTION(this) : null
                            }
                            </div>
                            {this.props.type==='popular'? null:<div style={{paddingRight:20, cursor: 'pointer'}} onClick={()=>{
                                window.location.hash = '#/newMedia/contentManagement';
                            }}>查看更多{">>"}</div>}
                        </div>
                        <PageTemplate style={{padding:'0px'}} >
                            <div className={'popular'} style={{display:'flex',justifyContent: 'space-between',
                                alignItems: "center"}}>
                                <TabsTemplate
                                    tabChange={this.onChange}
                                    nav={this.state.tabs}
                                    tabKey={this.state.currentTab}
                                    onResize={(offsetHeight) => {
                                        if (this.tabsHeight != offsetHeight) {
                                            this.tabsHeight = offsetHeight;
                                            this.setState({});
                                        }
                                    }}
                                />

                                {this.props.type==='popular'?
                                    <Sta_Date config={selectDateConfig}
                                              allowClear={true}
                                              callBack={(start, end) => {
                                                   this.state.startTime = start;
                                                   this.state.endTime = end;
                                                   this.getTopList(this.props.currentTabs)
                                    }}>
                                    </Sta_Date> : null}

                            </div>
                            <style>{`.popular .ant-tabs-bar{border-bottom:none !important}`}</style>

                        </PageTemplate>
                        <PageTemplate style={{padding:'0px'}} styleOut={{ margin:this.props.type==='last'?"0px 15px":'15px'}}>
                            <Scrollbars autoHide autoHeight autoHeightMax={400} >
                            <TableTemplate
                                // key={"TableTemplate" + tabKey}
                                // maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                                // maxHeight={this.tableContributeHeight}
                                columns={columns}
                                dataSource={this.props.type==='last'?this.state.dataSource1:this.state.dataSource2}
                                onResize={(offsetHeight) => {
                                    if (this.tableHeaderHeight != offsetHeight) {
                                        this.tableHeaderHeight = offsetHeight;
                                        this.setState({});
                                    }
                                }}
                            />
                            </Scrollbars>
                        </PageTemplate>
                    </div>
            </PageTemplate>
        )
    }

    onChange = (key) =>{
      this.setState({currentTab:key},()=>{
          if(this.props.type==='popular'){
              this.getTopList(this.props.currentTabs)
          }else{
              this.getList(this.props.currentTabs);
          }
      })
    }
}